<template>
    <div>
        <v-layout wrap row justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
                <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Generalidades del monitoreo de atmósferas</h1>
                <h2 v-if="onboarding<2" class="animated bounceIn dura-2">Consideraciones en el monitoreo de atmósferas asociadas al equipo</h2>
                <h2 v-if="onboarding>=2 && onboarding!=4" class="animated bounceIn dura-2">Consideraciones en el monitoreo de atmósferas asociadas a la actividad</h2>
                <h2 v-if="onboarding==4" class="animated bounceIn dura-2">Consideraciones generales para realizar pruebas de gases</h2>
                <p v-if="onboarding<2" class="animated fadeIn dura-3">Para realizar una prueba de gases es importante tener en cuenta que tanto el emisor como la persona que realiza la medición de gases deben cumplir con ciertos requisitos para garantizar la correcta aplicación de la prueba.</p>
                <p v-if="onboarding==4" class="animated fadeIn dura-3">La autoridad de área debe verificar que el monitoreo de atmósferas sea realizado por una persona autorizada.</p>
                <p v-if="onboarding==6" class="animated fadeIn dura-3">El monitoreo de atmósferas debe ser realizado, con la menor antelación posible al inicio del trabajo, de manera que sea representativo de las condiciones reinantes y de acuerdo con las características del trabajo.</p>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center">
                <div class="cont-pq">
                    <v-card color="transparent" flat tile>
                        <v-window v-model="onboarding">
                            <v-window-item v-for="n in length" :key="`card-${n}`">
                                <v-card class="cont_text-slider" color="transparent" flat>
                                    <div class="flip-item">
                                        <div class="slider-cont--img animated flipInY">
                                            <img :src="require('@/assets/unidad1/pantalla-8-'+(onboarding+1)+'.png')" alt="">
                                        </div>
                                        <v-card class="cont_text-slider-1" color="transparent" flat>
                                            <div class="flip-item-1">
                                                <p class="mt-2">{{complemento[onboarding]}}</p>
                                            </div>
                                        </v-card>
                                    </div>
                                </v-card>
                            </v-window-item>
                        </v-window>
                        <v-card-actions class="cont_buttons-slider">
                            <v-item-group light v-model="onboarding" class="text-center " mandatory>
                                <v-item v-for="n in length" :key="`btn-${n}`" v-slot:default="{ active, toggle }">
                                    <v-btn :color="vistos[n-1] ? '#FFAF50' : '#28F7D1'" small class="item-button" :input-value="active" icon @click="toggle">
                                        <v-icon>mdi-record</v-icon>
                                    </v-btn>
                                </v-item>
                            </v-item-group>
                        </v-card-actions>
                    </v-card>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
    mixins: [nextConditions],
    data() {
        return {
            vistos: Array(7).fill(false),
            bottomNav: "recent",
            onboarding: 0,
            length: 7,
            complemento: [
                'El Equipo Detector de Gas está diseñado para detectar solamente gases específicos para los cuales haya un sensor instalado.',
                'Utilizar un equipo portátil detector de gases que cumpla con las especificaciones descritas.',
                'El emisor del permiso debe garantizar condiciones adecuadas para iniciar un trabajo y por ende es responsable de la prueba de gases.',
                'El monitoreo de atmósferas no se debe realizar cuando se presente precipitación (lluvia) o vapor de agua en el ambiente, ya que los resultados no serían confiables.',
                'La persona que realice el monitoreo de atmósferas deberá estar avalada según los requerimientos del Instructivo para la realización de monitoreo de atmósferas y calibración de equipos portátiles para monitoreo de gases.',
                'Se debe consultar el manual del equipo de monitoreo de atmósferas que estén usando o calibrando para identificar otras posibles interferencias o limitaciones de los equipos.',
                'El monitoreo de atmósferas debe ser realizado, con la menor antelación posible al inicio del trabajo, de manera que sea representativo de las condiciones reinantes y de acuerdo con las características del trabajo.',
            ]
        }
    },
    mounted() {
        this.$set(this.vistos, 0, true)
        setTimeout(() => {
            this.$store.commit('nextShow', false)
        }, 3000);
    },
    watch: {
        onboarding(val) {
            this.$set(this.vistos, val, true)
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../sass/globals';
.cont_buttons-slider-1 {
    justify-content: center;
    .item-button {
        width: 15px;
        height: 15px;
    }
}

.flip-item-1 {
    position: relative;
    width: 100%;
    height: auto;
    padding: 10px;
    background: white;
    p {
        text-align: center;
    }
    .pb {
        color: $color-secondary;
        font-family: FontBase-Bold;
    }
    @media screen and (max-width: 330px) {
        img {
            width: 150px;
        }
    }
}

.cont-pq {
    width: 60%;
    margin: 0 auto;
    @media screen and (max-width: 330px) {
        width: 100%;
    }
}

.btn-img--wb {
    width: 120px;
}

.cont_buttons-slider {
    justify-content: center;
    .item-button {
        width: 15px;
        height: 15px;
    }
}

.flip-item {
    position: relative;
    width: 100%;
    height: auto;
    padding: 10px;
    p {
        text-align: center;
        margin: 0;
        padding: 0;
    }
    @media screen and (max-width: 330px) {
        img {
            width: 150px;
        }
    }
}

.slider-cont--img {
    margin: 0 auto;
    min-width: 200px;
    min-height: 212px;
    img {
        width: 40%;
    }
    @media screen and (max-width: 1650px) {
        min-width: 100% !important;
        min-height: 100px;
        img {
            width: 70%;
        }
    }
    @media screen and (max-width: 950px) {
        min-width: 100% !important;
        min-height: 100px;
        img {
            width: 100%;
        }
    }
}

.pantalla {
    @media screen and (max-width: 600px) {
        display: none;
    }
}

.mobile {
    @media screen and (min-width: 600px) {
        display: none;
    }
    @media screen and (max-width: 600px) {
        display: block;
    }
}
</style>